/* La Casa del Panettone — theme.js */

// Pantalla de carga: espera a que cargue la página (mínimo 1 s para que se
// vea el logo, máximo 4 s) y lanza la salida; se quita al terminar.
(() => {
  // Enlaces que no deben mostrar la pantalla de carga en la página de destino
  document.addEventListener('click', (e) => {
    if (e.target.closest('a[data-no-loader]')) {
      try { sessionStorage.setItem('lcdp-skip-loader', '1'); } catch (err) {}
    }
  });
  // Ni al enviar un formulario de contacto o el "Avísame" (la página se recarga con el mensaje)
  document.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/contact"]')) {
      try { sessionStorage.setItem('lcdp-skip-loader', '1'); } catch (err) {}
    }
  });
  const loader = document.querySelector('[data-loader]');
  if (!loader) return;
  try { sessionStorage.setItem('lcdp-loader', '1'); } catch (e) {}
  const start = performance.now();
  let done = false;
  const leave = () => {
    if (done) return;
    done = true;
    const wait = Math.max(1000 - (performance.now() - start), 0);
    setTimeout(() => {
      loader.classList.add('is-leaving');
      document.dispatchEvent(new CustomEvent('lcdp:loader-leaving'));
      setTimeout(() => loader.remove(), 1500);
    }, wait);
  };
  if (document.readyState === 'complete') leave();
  else window.addEventListener('load', leave, { once: true });
  setTimeout(leave, 4000);
})();

// Menú móvil: abre/cierra (la animación es CSS) y oscurece el resto de la
// página; se cierra tocando fuera o con Escape
const setNavOpen = (open) => {
  const toggle = document.querySelector('[data-nav-toggle]');
  if (!toggle) return;
  const nav = document.getElementById(toggle.getAttribute('aria-controls'));
  toggle.setAttribute('aria-expanded', String(open));
  nav?.classList.toggle('is-open', open);
  document.querySelector('[data-nav-overlay]')?.classList.toggle('is-visible', open);
};
document.querySelectorAll('.site-nav__list > li').forEach((item, i) => item.style.setProperty('--i', i));
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-nav-toggle]');
  if (toggle) setNavOpen(toggle.getAttribute('aria-expanded') !== 'true');
  else if (event.target.closest('[data-nav-overlay]')) setNavOpen(false);
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setNavOpen(false);
});

// Precio según variante seleccionada
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const price = select.closest('[data-product]')?.querySelector('[data-price]');
  if (price && option?.dataset.price) price.textContent = option.dataset.price;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url);
});

// Selector de cantidad (− / +)
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-qty-step]');
  if (!button) return;
  const input = button.closest('[data-qty]')?.querySelector('input');
  if (!input) return;
  const min = parseInt(input.min, 10) || 1;
  const value = (parseInt(input.value, 10) || min) + Number(button.dataset.qtyStep);
  input.value = Math.max(min, value);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// Pestañas: clic y flechas del teclado
document.querySelectorAll('[data-tabs]').forEach((tabs) => {
  const buttons = [...tabs.querySelectorAll('[role="tab"]')];
  const list = tabs.querySelector('[role="tablist"]');
  const indicator = document.createElement('span');
  indicator.className = 'tabs__indicator';
  indicator.setAttribute('aria-hidden', 'true');
  list?.append(indicator);
  tabs.classList.add('has-indicator');
  const move = () => {
    const tab = buttons.find((b) => b.getAttribute('aria-selected') === 'true');
    if (!tab) return;
    indicator.style.width = `${tab.offsetWidth}px`;
    indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
  };
  const select = (tab) => {
    buttons.forEach((b) => {
      const active = b === tab;
      b.setAttribute('aria-selected', String(active));
      b.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(b.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    move();
  };
  // Primera colocación sin animación; se recoloca al cambiar el tamaño o al cargar la fuente
  indicator.style.transition = 'none';
  move();
  requestAnimationFrame(() => { indicator.style.transition = ''; });
  window.addEventListener('resize', move);
  document.fonts?.ready.then(move);
  buttons.forEach((b, i) => {
    b.addEventListener('click', () => select(b));
    b.addEventListener('keydown', (event) => {
      const dir = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
      if (!dir) return;
      const next = buttons[(i + dir + buttons.length) % buttons.length];
      select(next);
      next.focus();
    });
  });
});

// Alto de la cabecera (barra superior incluida) en --header-bottom, para las
// portadas que ocupan el resto de la pantalla (p. ej. Sobre nosotros).
(() => {
  const header = document.querySelector('[data-header]');
  if (!header) return;
  const set = () => {
    const bottom = header.getBoundingClientRect().bottom + window.scrollY;
    document.documentElement.style.setProperty('--header-bottom', `${Math.round(bottom)}px`);
  };
  set();
  window.addEventListener('resize', set);
})();

// Botón de sonido: alterna el estado y avisa al resto del tema con 'theme:sound'
// (detail.on = true/false). Se recuerda la preferencia durante la sesión.
(() => {
  const KEY = 'lcdp-sound';
  const buttons = () => document.querySelectorAll('[data-sound-toggle]');
  const apply = (on) => {
    buttons().forEach((b) => b.setAttribute('aria-pressed', String(on)));
    document.dispatchEvent(new CustomEvent('theme:sound', { detail: { on } }));
  };
  let stored = false;
  try { stored = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
  if (stored) document.addEventListener('DOMContentLoaded', () => apply(true));

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sound-toggle]');
    if (!button) return;
    const on = button.getAttribute('aria-pressed') !== 'true';
    try { sessionStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {}
    apply(on);
  });
})();

// Aviso del sonido: bocadillo bajo el altavoz al entrar (una vez por sesión,
// tras la pantalla de carga). Se cierra con la X, al activar el sonido o a los 10 s.
(() => {
  const hint = document.querySelector('[data-sound-hint]');
  if (!hint) return;
  const KEY = 'lcdp-sound-hint';
  try {
    if (sessionStorage.getItem(KEY) === '1' || sessionStorage.getItem('lcdp-sound') === '1') return;
  } catch (e) {}
  let timer;
  const hide = () => {
    clearTimeout(timer);
    hint.classList.remove('is-visible');
    setTimeout(() => { hint.hidden = true; }, 450);
  };
  const show = () => {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    hint.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => hint.classList.add('is-visible')));
    timer = setTimeout(hide, 10000);
  };
  hint.querySelector('[data-sound-hint-close]').addEventListener('click', hide);
  document.addEventListener('theme:sound', (event) => { if (event.detail.on) hide(); });
  if (document.querySelector('[data-loader]')) {
    document.addEventListener('lcdp:loader-leaving', () => setTimeout(show, 900), { once: true });
  } else {
    setTimeout(show, 1200);
  }
})();

// Música de fondo: suena con el botón de sonido. Recuerda por dónde iba al
// cambiar de página. Si el navegador bloquea el arranque sin interacción
// (al volver con el sonido activado), empieza con el primer toque o tecla.
(() => {
  const audio = document.querySelector('[data-site-music]');
  if (!audio) return;
  const TIME_KEY = 'lcdp-music-time';
  audio.volume = 0.5;
  let resumed = false;
  const resume = () => {
    if (resumed) return;
    resumed = true;
    try {
      const t = parseFloat(sessionStorage.getItem(TIME_KEY));
      if (t > 0) audio.currentTime = t;
    } catch (e) {}
  };
  // En móvil solo cuentan como interacción levantar el dedo (touchend /
  // pointerup) o el clic, no apoyarlo: se escucha todo y se reintenta hasta
  // que suene. Ningún navegador móvil deja sonar una página nueva sin un toque
  const GESTURES = ['pointerdown', 'pointerup', 'touchend', 'click', 'keydown'];
  const startOnGesture = () => {
    const go = () => {
      const stop = () => GESTURES.forEach((type) => document.removeEventListener(type, go, true));
      if (!document.querySelector('[data-sound-toggle][aria-pressed="true"]')) return stop();
      audio.play().then(stop, () => {});
    };
    GESTURES.forEach((type) => document.addEventListener(type, go, true));
  };
  document.addEventListener('theme:sound', (event) => {
    if (event.detail.on) {
      if (audio.readyState === 0) audio.addEventListener('loadedmetadata', resume, { once: true });
      else resume();
      audio.play().catch(startOnGesture);
    } else {
      audio.pause();
    }
  });
  window.addEventListener('pagehide', () => {
    try { sessionStorage.setItem(TIME_KEY, String(audio.currentTime)); } catch (e) {}
  });
})();

// Hero: el panettone gira con el scroll. Dibuja en un <canvas> el fotograma
// que corresponde al avance del scroll mientras se ve en pantalla (una vuelta completa).
(() => {
  const canvas = document.querySelector('[data-hero-rotate]');
  if (!canvas) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const urls = canvas.dataset.frames.split(',').map((u) => u.trim()).filter(Boolean);
  const ctx = canvas.getContext('2d');
  const media = canvas.closest('.hero__media');
  const hero = canvas.closest('.hero');
  const frames = new Array(urls.length);
  let current = -1;
  let ticking = false;

  const draw = (index) => {
    // Si el fotograma aún no ha cargado, usa el más cercano que sí lo esté
    let i = index;
    while (i > 0 && !frames[i]?.complete) i--;
    const img = frames[i];
    if (!img?.complete || i === current) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    current = i;
  };

  const update = () => {
    ticking = false;
    // Avance desde el primer píxel de scroll hasta que el panettone sale
    // del todo por arriba: gira durante todo el tiempo que se ve en pantalla
    const end = (media || hero).getBoundingClientRect().bottom + window.scrollY;
    const progress = Math.min(Math.max(window.scrollY / Math.max(end, 1), 0), 1);
    draw(Math.round(progress * (urls.length - 1)));
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const load = () => {
    urls.forEach((url, i) => {
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
      frames[i] = img;
      if (i === 0) {
        img.onload = () => { draw(0); media?.classList.add('is-ready'); update(); };
      }
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  };

  // Empieza a cargar los fotogramas en cuanto el HTML está listo
  if (document.readyState !== 'loading') load();
  else document.addEventListener('DOMContentLoaded', load, { once: true });
})();

// Carruseles con flechas: desplazan una tarjeta y se desactivan en los extremos
// (con data-carousel-loop las flechas no se desactivan y dan la vuelta)
document.querySelectorAll('[data-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-carousel-track]');
  const prev = carousel.querySelector('[data-carousel-prev]');
  const next = carousel.querySelector('[data-carousel-next]');
  if (!track) return;

  const step = () => {
    const item = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
  };
  const loop = carousel.hasAttribute('data-carousel-loop');

  // Desplazamiento animado propio (más lento y suave que el nativo):
  // easeInOutCubic en 750 ms, sin el encaje de scroll-snap mientras dura
  let frame = null;
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);
  const animateTo = (left, curve = ease, duration = 750) => {
    cancelAnimationFrame(frame);
    const max = track.scrollWidth - track.clientWidth;
    const from = track.scrollLeft;
    const to = Math.min(Math.max(left, 0), max);
    if (Math.abs(to - from) < 1 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.scrollLeft = to;
      track.classList.remove('is-animating');
      return;
    }
    const start = performance.now();
    track.classList.add('is-animating');
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      track.scrollLeft = from + (to - from) * curve(t);
      if (t < 1) frame = requestAnimationFrame(tick);
      else track.classList.remove('is-animating');
    };
    frame = requestAnimationFrame(tick);
  };
  const update = () => {
    if (loop) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  };

  // Arrastrar con el ratón (en táctil ya se desliza de forma nativa)
  let startX = 0;
  let startScroll = 0;
  let dragging = false;
  let moved = false;
  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    dragging = true;
    moved = false;
    startX = event.clientX;
    startScroll = track.scrollLeft;
  });
  window.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    const dx = event.clientX - startX;
    if (!moved && Math.abs(dx) > 5) {
      moved = true;
      track.classList.add('is-dragging');
    }
    if (moved) track.scrollLeft = startScroll - dx;
  });
  window.addEventListener('pointerup', (event) => {
    if (!dragging) return;
    dragging = false;
    if (!moved) return;
    // Al soltar, encaja en la tarjeta más cercana; con arrastrar un 15 % ya
    // pasa a la siguiente (en bucle, también desde la última). Sigue sin
    // frenar: desaceleración corta en vez de arrancar despacio
    const s = step();
    const dx = event.clientX - startX;
    const dir = dx < 0 ? 1 : -1;
    const current = track.scrollLeft;
    let index = Math.round(current / s);
    if (index === Math.round(startScroll / s) && Math.abs(dx) > s * 0.15) index += dir;
    let target = index * s;
    track.classList.add('is-animating');
    track.classList.remove('is-dragging');
    const max = track.scrollWidth - track.clientWidth;
    if (loop && target > max + 2) {
      track.append(track.firstElementChild);
      jump(current - s);
      target -= s;
    } else if (loop && target < -2) {
      track.prepend(track.lastElementChild);
      jump(current + s);
      target += s;
    }
    animateTo(target, easeOut, 450);
  });
  // Si se ha arrastrado, que soltar sobre una tarjeta no abra su enlace
  track.addEventListener('click', (event) => {
    if (moved) {
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }
  }, true);
  track.addEventListener('dragstart', (event) => event.preventDefault());

  // En bucle, al llegar a un extremo se pasa la foto del otro lado delante
  // (sin que se note) para que siempre avance en la dirección de la flecha
  const jump = (left) => {
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = left;
    track.style.scrollBehavior = '';
  };
  const go = (dir) => {
    const s = step();
    // En bucle hace falta que sobre al menos una tarjeta: si caben todas,
    // se duplican (copias ocultas a lectores de pantalla)
    if (loop && track.children.length && track.scrollWidth - track.clientWidth < s) {
      [...track.children].forEach((item) => {
        const copy = item.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('data-shopify-editor-block');
        track.append(copy);
      });
    }
    const max = track.scrollWidth - track.clientWidth - 2;
    // La posición se lee antes de reordenar: al mover una foto el navegador
    // vuelve a encajar la vista (scroll-snap) y scrollLeft ya no sirve
    const current = track.scrollLeft;
    if (loop && dir > 0 && current >= max) {
      track.append(track.firstElementChild);
      jump(current - s);
    } else if (loop && dir < 0 && current <= 2) {
      track.prepend(track.lastElementChild);
      jump(current + s);
    }
    animateTo(track.scrollLeft + dir * s);
  };
  prev?.addEventListener('click', () => go(-1));

  // En bucle, al deslizar con el dedo (scroll nativo) tampoco hay final:
  // cuando se para en un extremo, se pasa la foto del otro lado delante sin
  // que se note, así siempre queda una a cada lado. No se toca con el dedo
  // encima ni mientras dura una animación o un arrastre con el ratón
  if (loop) {
    let touching = false;
    let settle = null;
    const recenter = () => {
      if (touching || dragging || track.classList.contains('is-animating')) return;
      const s = step();
      if (!track.children.length) return;
      // Hacen falta al menos dos de más para tener vecina a los dos lados
      if (track.scrollWidth - track.clientWidth < s * 2) {
        [...track.children].forEach((item) => {
          const copy = item.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('data-shopify-editor-block');
          track.append(copy);
        });
      }
      const max = track.scrollWidth - track.clientWidth - 2;
      const current = track.scrollLeft;
      if (current >= max) {
        track.append(track.firstElementChild);
        jump(current - s);
      } else if (current <= 2) {
        track.prepend(track.lastElementChild);
        jump(current + s);
      }
    };
    const schedule = () => {
      clearTimeout(settle);
      settle = setTimeout(recenter, 150);
    };
    track.addEventListener('touchstart', () => { touching = true; clearTimeout(settle); }, { passive: true });
    track.addEventListener('touchend', () => { touching = false; schedule(); }, { passive: true });
    track.addEventListener('touchcancel', () => { touching = false; schedule(); }, { passive: true });
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('load', recenter);
    recenter();
  }
  next?.addEventListener('click', () => go(1));

  // Avance automático tarjeta a tarjeta; se pausa con el ratón encima,
  // al tocar, con el foco dentro o con la pestaña oculta
  const delay = Number(carousel.dataset.carouselAutoplay);
  if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let paused = false;
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    carousel.addEventListener('mouseenter', pause);
    carousel.addEventListener('mouseleave', resume);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', resume);
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', () => setTimeout(resume, delay), { passive: true });
    setInterval(() => {
      if (!paused && !document.hidden && !dragging) go(1);
    }, delay);
  }
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
});

// Galería con scroll horizontal (escritorio): la sección mide el alto de la
// pantalla más el recorrido horizontal de las fotos; mientras está fija, el
// scroll vertical se traduce en desplazamiento horizontal.
document.querySelectorAll('[data-hscroll]').forEach((section) => {
  const track = section.querySelector('[data-hscroll-track]');
  const viewport = section.querySelector('[data-hscroll-viewport]');
  if (!track || !viewport) return;
  const desktop = window.matchMedia('(min-width: 750px)');
  let distance = 0;
  // Tramo de scroll al llegar en el que la sección se queda quieta antes de
  // empezar a desplazarse (40% del alto de la pantalla)
  let pause = 0;
  let ticking = false;

  const measure = () => {
    if (!desktop.matches) {
      section.style.height = '';
      track.style.transform = '';
      return;
    }
    distance = Math.max(track.scrollWidth - viewport.clientWidth, 0);
    pause = Math.round(window.innerHeight * 0.4);
    section.style.height = `${window.innerHeight + pause + distance}px`;
    update();
  };

  const update = () => {
    ticking = false;
    if (!desktop.matches) return;
    const top = section.getBoundingClientRect().top;
    const progress = Math.min(Math.max((-top - pause) / Math.max(distance, 1), 0), 1);
    track.style.transform = `translate3d(${-progress * distance}px, 0, 0)`;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', measure);
  desktop.addEventListener('change', measure);
  track.querySelectorAll('img').forEach((img) => img.complete || img.addEventListener('load', measure, { once: true }));
  measure();
});

// Animación de entrada: marca [data-reveal] cuando entra en pantalla
(() => {
  const items = document.querySelectorAll('[data-reveal]');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-revealed'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });
  items.forEach((el) => observer.observe(el));
})();

// Animaciones de entrada de la portada (GSAP + SplitText). [data-anim]:
//   lines  → títulos: las líneas suben desde una máscara
//   text   → párrafos: igual, más suave y con fundido
//   fade   → pretítulos, botones…: suben un poco y aparecen
//   pop    → sellos: aparecen con un pequeño rebote
//   reveal → rótulo del hero: sube desde el borde inferior
//   slide  → fotos laterales: entran desde fuera de la pantalla girando hasta
//            su ángulo (data-anim-from="left|right"); van a la vez, sin escalonar
//   rise   → pegatinas: suben desde abajo y aparecen
// Opcionales: data-anim-start (punto de ScrollTrigger), data-anim-trigger
// (selector del contenedor que dispara) y data-anim-delay (retraso fijo, s).
// Lo que entra a la vez en pantalla se escalona en orden. Si hay pantalla de
// carga, esperan a que se recoja.
(() => {
  const showAll = (root) => root.querySelectorAll('[data-anim]').forEach((el) => { el.style.visibility = 'visible'; });
  const { gsap, ScrollTrigger, SplitText } = window;
  if (!gsap || !ScrollTrigger || !SplitText || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    showAll(document);
    return;
  }
  gsap.registerPlugin(ScrollTrigger, SplitText);

  // Retraso escalonado para lo que se dispara en el mismo fotograma
  let queued = 0;
  let frame;
  const nextDelay = () => {
    const delay = Math.min(queued++ * 0.12, 0.6);
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => { queued = 0; });
    return delay;
  };

  const splitLines = (el, delay, vars) => {
    const paragraphs = el.querySelectorAll(':scope > p');
    const split = SplitText.create(paragraphs.length ? paragraphs : el, { type: 'lines', mask: 'lines', linesClass: 'anim-line' });
    gsap.set(el, { visibility: 'visible' });
    gsap.from(split.lines, { yPercent: 105, delay, ...vars, onComplete: () => split.revert() });
  };

  const animations = {
    lines: (el, delay) => splitLines(el, delay, { duration: 1.2, ease: 'expo.out', stagger: 0.1 }),
    text: (el, delay) => splitLines(el, delay, { opacity: 0, duration: 1.1, ease: 'power4.out', stagger: 0.07 }),
    fade: (el, delay) => gsap.fromTo(el,
      { autoAlpha: 0, y: 32, transition: 'none' },
      { autoAlpha: 1, y: 0, delay, duration: 1, ease: 'power3.out', clearProps: 'transform,transition,opacity' }),
    pop: (el, delay) => gsap.fromTo(el,
      { autoAlpha: 0, scale: 0.6, rotation: -14, transition: 'none' },
      { autoAlpha: 1, scale: 1, rotation: 0, delay, duration: 1, ease: 'back.out(1.7)', clearProps: 'transform,transition,opacity' }),
    slide: (el) => {
      const dir = el.dataset.animFrom === 'right' ? 1 : -1;
      gsap.set(el, { visibility: 'visible' });
      gsap.from(el, { xPercent: 110 * dir, rotation: `+=${70 * dir}`, duration: 1.6, ease: 'expo.out', clearProps: 'transform' });
    },
    rise: (el, delay) => {
      gsap.set(el, { visibility: 'visible' });
      gsap.from(el.firstElementChild || el, { autoAlpha: 0, y: 140, scale: 0.85, delay, duration: 1.1, ease: 'power3.out' });
    },
    reveal: (el, delay) => {
      gsap.set(el, { visibility: 'visible', clipPath: 'inset(0 0 0 0)' });
      gsap.from(el.firstElementChild || el, { yPercent: 100, delay, duration: 1.5, ease: 'expo.out', onComplete: () => gsap.set(el, { clearProps: 'clipPath' }) });
    },
  };

  const desktop = window.matchMedia('(min-width: 750px)');
  const init = (root) => {
    root.querySelectorAll('[data-anim]').forEach((el) => {
      const animate = animations[el.dataset.anim];
      if (!animate) { el.style.visibility = 'visible'; return; }
      // onLeave cubre lo que ya quedó por encima (recarga a mitad de página)
      let done = false;
      const run = (self) => {
        if (done) return;
        done = true;
        self.kill();
        const { animDelay } = el.dataset;
        animate(el, animDelay ? Number(animDelay) : el.dataset.anim === 'slide' ? 0 : nextDelay());
      };
      // En la galería horizontal (escritorio) el texto va fijo y centrado en
      // una pantalla entera: se dispara con la sección ya bien dentro
      const hscroll = desktop.matches && el.closest('[data-hscroll]');
      ScrollTrigger.create({
        trigger: (el.dataset.animTrigger && el.closest(el.dataset.animTrigger))
          || hscroll
          || (el.dataset.anim === 'slide' ? el.parentElement : el),
        start: el.dataset.animStart || (hscroll ? 'top 50%' : 'top 85%'),
        onEnter: run,
        onLeave: run,
      });
    });
  };

  // Las fotos lazy (y la galería horizontal, que fija su alto al cargarlas)
  // cambian el alto de la página: se recalculan los puntos de disparo para que
  // no salten antes de tiempo
  let refreshTimer;
  new ResizeObserver(() => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => ScrollTrigger.refresh(), 150);
  }).observe(document.body);

  const start = () => (document.fonts?.ready || Promise.resolve()).then(() => init(document));
  if (document.querySelector('[data-loader]')) {
    // Arrancan cuando la capa de color empieza a desvanecerse
    document.addEventListener('lcdp:loader-leaving', () => setTimeout(start, 800), { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    ScrollTrigger.refresh();
  });
})();

// Pegatinas de la sección de packs: se pueden arrastrar por la sección (se
// mueve la pegatina, no el contenedor, para no pisar su posición y su giro).
(() => {
  const { gsap, Draggable } = window;
  if (!gsap || !Draggable) return;
  gsap.registerPlugin(Draggable);
  let zIndex = 2;
  document.querySelectorAll('[data-sticker-drag]').forEach((sticker) => {
    // Se mueve la pegatina con su solapa; el despegado lo hace el CSS (.is-peeled)
    const peel = sticker.querySelector('.sticker-peel') || sticker.querySelector('img');
    if (!peel) return;
    Draggable.create(peel, {
      bounds: sticker.closest('.stickers-cta'),
      onPress() {
        sticker.style.zIndex = ++zIndex;
        peel.classList.add('is-peeled');
      },
      onRelease() {
        peel.classList.remove('is-peeled');
      },
    });
  });
})();

// Reseñas de Google en directo (API Places de Google Maps). Solo se activa si
// la sección tiene clave y Place ID; si algo falla se quedan las de los bloques.
document.querySelectorAll('[data-google-reviews]').forEach(async (section) => {
  const { apiKey, placeId } = section.dataset;
  const minRating = Number(section.dataset.minRating) || 1;
  try {
    if (!window.google?.maps?.importLibrary) {
      await new Promise((resolve, reject) => {
        window.__lcdpMapsReady = resolve;
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&loading=async&language=es&callback=__lcdpMapsReady`;
        script.async = true;
        script.onerror = reject;
        document.head.append(script);
      });
    }
    const { Place } = await google.maps.importLibrary('places');
    const place = new Place({ id: placeId, requestedLanguage: 'es' });
    await place.fetchFields({ fields: ['rating', 'userRatingCount', 'reviews'] });

    const rating = section.querySelector('[data-reviews-rating]');
    const count = section.querySelector('[data-reviews-count]');
    if (rating && place.rating) rating.textContent = place.rating.toFixed(1).replace('.', ',');
    if (count && place.userRatingCount) count.textContent = place.userRatingCount;

    const reviews = (place.reviews || []).filter((r) => r.rating >= minRating && r.text);
    if (!reviews.length) return;
    const list = section.querySelector('[data-reviews-list]');
    const card = section.querySelector('[data-review-template]');
    const star = section.querySelector('[data-star-template]');
    list.replaceChildren(...reviews.map((review) => {
      const item = card.content.firstElementChild.cloneNode(true);
      const stars = item.querySelector('.review-card__stars');
      stars.setAttribute('aria-label', `${review.rating} / 5`);
      for (let i = 0; i < Math.round(review.rating); i++) stars.append(star.content.cloneNode(true));
      const text = item.querySelector('.review-card__text');
      text.textContent = review.text;
      text.style.whiteSpace = 'pre-line';
      item.querySelector('.review-card__author').textContent = review.authorAttribution?.displayName || '';
      return item;
    }));
  } catch (error) {
    console.warn('Reseñas de Google no disponibles', error);
  }
});

// Reseñas en móvil: un punto por reseña. Cada tarjeta lleva su número
// (data-dot) porque el carrusel en bucle las reordena y duplica; las copias
// heredan el número de su original.
document.querySelectorAll('[data-reviews-dots]').forEach((dots) => {
  const track = dots.closest('[data-carousel]')?.querySelector('[data-carousel-track]');
  if (!track) return;
  const label = (n) => `${n} / ${track.querySelectorAll('[data-dot]:not([aria-hidden])').length}`;
  const current = () => {
    let best = null;
    let distance = Infinity;
    [...track.children].forEach((card) => {
      const d = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
      if (d < distance) { distance = d; best = card; }
    });
    return best?.dataset.dot;
  };
  const paint = () => {
    const active = current();
    dots.querySelectorAll('.reviews__dot').forEach((dot) => {
      dot.setAttribute('aria-current', String(dot.dataset.target === active));
    });
  };
  const build = () => {
    const cards = [...track.children].filter((card) => !card.hasAttribute('aria-hidden'));
    // Lista nueva (p. ej. reseñas cargadas de Google): se numeran de nuevo
    if (cards.every((card) => !card.dataset.dot)) cards.forEach((card, i) => { card.dataset.dot = String(i); });
    else return paint();
    dots.replaceChildren(...cards.map((card, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'reviews__dot';
      dot.dataset.target = String(i);
      dot.setAttribute('aria-label', label(i + 1));
      dot.addEventListener('click', () => {
        const target = [...track.children].find((c) => c.dataset.dot === String(i) && !c.hasAttribute('aria-hidden'));
        if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      return dot;
    }));
    paint();
  };
  new MutationObserver(build).observe(track, { childList: true });
  track.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
  build();
});

// Productos relacionados: cambia los de la misma colección por las
// recomendaciones de Shopify si devuelve alguna
document.querySelectorAll('[data-recommendations]').forEach(async (section) => {
  try {
    const response = await fetch(section.dataset.url);
    if (!response.ok) return;
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const list = html.querySelector('[data-recommendations-list]');
    if (!list) return;
    // La respuesta trae uno de más por si incluye el producto que se está viendo
    list.querySelector(`[data-product-id="${section.dataset.productId}"]`)?.remove();
    [...list.children].slice(Number(section.dataset.limit) || 4).forEach((item) => item.remove());
    if (list.children.length) section.querySelector('[data-recommendations-list]')?.replaceWith(list);
  } catch (error) {
    console.warn('Recomendaciones no disponibles', error);
  }
});

// Carrito lateral: se abre desde el icono del carrito y al añadir un producto.
// Tras cada cambio pide la sección ya pintada (sections) y sustituye el contenido.
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const panel = drawer.querySelector('.cart-drawer__panel');
  const sectionId = drawer.dataset.sectionId;
  let lastFocus = null;

  const open = () => {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('has-drawer');
    setTimeout(() => drawer.querySelector('.cart-drawer__close')?.focus(), 50);
  };
  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('has-drawer');
    lastFocus?.focus?.();
  };

  const render = (sections) => {
    const html = sections?.[sectionId];
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawerContent');
    const current = drawer.querySelector('#CartDrawerContent');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    const count = Number(fresh.dataset.cartCountValue) || 0;
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  };

  const request = async (url, body) => {
    panel.classList.add('is-loading');
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: sectionId, sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || '');
      render(data.sections);
      return true;
    } catch (error) {
      const message = drawer.querySelector('[data-cart-error]');
      if (message) {
        message.textContent = error.message;
        message.hidden = !error.message;
      }
      return false;
    } finally {
      panel.classList.remove('is-loading');
    }
  };

  // Al volver con "atrás" (p. ej. desde el checkout) el navegador enseña la
  // página guardada con la cesta de entonces: se pide de nuevo
  const refresh = async () => {
    try {
      const response = await fetch(`${window.location.pathname}?sections=${sectionId}`, { headers: { Accept: 'application/json' } });
      if (response.ok) render(await response.json());
    } catch (error) {}
  };
  window.addEventListener('pageshow', (event) => {
    const back = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (!event.persisted && !back) return;
    // La página de la cesta se pinta en el servidor: se recarga entera
    if (document.body.classList.contains('template-cart')) window.location.reload();
    else refresh();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.site-header__cart')) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      close();
      return;
    }
    const qty = event.target.closest('[data-cart-qty]');
    if (qty) {
      request(drawer.dataset.changeUrl, { line: Number(qty.dataset.cartLine), quantity: Number(qty.dataset.cartQty) });
      return;
    }
    const add = event.target.closest('[data-cart-add]');
    if (add) {
      // Desde una tarjeta de producto: añade y abre la cesta
      const fromCard = !drawer.contains(add);
      add.classList.add('is-adding');
      request(drawer.dataset.addUrl, { items: [{ id: Number(add.dataset.cartAdd), quantity: 1 }] }).then(() => {
        add.classList.remove('is-adding');
        if (fromCard) open();
      });
    }
  });

  // Formulario de la ficha de producto: añade sin salir de la página
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const data = new FormData(form);
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    await request(drawer.dataset.addUrl, {
      items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 }],
    });
    if (button) button.disabled = false;
    open();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();

// Filtros de la página de productos: cargan la colección sin recargar la
// página (Section Rendering API) y actualizan la URL; atrás/adelante también.
(() => {
  const selector = '[data-catalog]';
  if (!document.querySelector(selector)) return;

  const load = async (url, push) => {
    const current = document.querySelector(selector);
    if (!current) return;
    current.classList.add('is-loading');
    try {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', current.dataset.sectionId);
      const response = await fetch(target);
      if (!response.ok) throw new Error(response.status);
      const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector(selector);
      if (!fresh) throw new Error('sin sección');
      current.replaceWith(fresh);
      if (push) window.history.pushState({ catalog: true }, '', url);
    } catch (error) {
      window.location.href = url;
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.catalog-filters__chip, [data-catalog] .pagination a');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    if (link.getAttribute('aria-current') === 'page') return;
    load(link.href, true);
  });

  window.addEventListener('popstate', () => load(window.location.href, false));
})();

// Vista del catálogo en móvil (1 o 2 por fila). Se guarda en <html> para que
// sobreviva al cambio de filtro, que sustituye la sección entera.
(() => {
  const root = document.documentElement;
  const key = 'lcdp-catalog-view';
  const sync = () => {
    const view = root.dataset.catalogView || '1';
    document.querySelectorAll('.catalog-view__btn[data-view]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.view === view));
    });
  };
  try { const saved = localStorage.getItem(key); if (saved) root.dataset.catalogView = saved; } catch (error) {}
  sync();
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.catalog-view__btn[data-view]');
    if (!button) return;
    root.dataset.catalogView = button.dataset.view;
    try { localStorage.setItem(key, button.dataset.view); } catch (error) {}
    sync();
  });
  // Al cambiar de filtro la sección se sustituye: vuelve a marcar el botón activo
  const holder = document.querySelector('[data-catalog]')?.parentElement;
  if (holder) new MutationObserver(sync).observe(holder, { childList: true });
})();

// Buscador de la cabecera: abre el panel y enfoca el campo; Intro envía el
// formulario a la página de resultados
(() => {
  const drawer = document.querySelector('[data-search-drawer]');
  if (!drawer) return;
  const input = drawer.querySelector('input[name="q"]');
  let lastFocus = null;
  const open = () => {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setTimeout(() => input?.focus(), 80);
  };
  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lastFocus?.focus?.();
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-search-toggle]')) {
      event.preventDefault();
      drawer.classList.contains('is-open') ? close() : open();
    } else if (event.target.closest('[data-search-close]')) {
      close();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
  drawer.querySelector('form')?.addEventListener('submit', (event) => {
    if (!input?.value.trim()) event.preventDefault();
  });
})();

/* Lightbox: [data-lightbox-open="<id>"] abre el <dialog data-lightbox> con ese
   id; se cierra con la X, Esc (nativo del dialog) o pulsando en cualquier sitio */
(() => {
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-lightbox-open]');
    if (opener) {
      document.getElementById(opener.dataset.lightboxOpen)?.showModal();
      return;
    }
    const dialog = event.target.closest('[data-lightbox]');
    if (dialog) dialog.close();
  });
})();

/* Ficha: "Pídelo antes de las HH:MM y se envía hoy". Cuenta con la hora de
   España; los días sin envío son sábados (salvo data-saturday), domingos y la
   lista data-holidays (DD/MM cada año o DD/MM/AAAA) */
(() => {
  const el = document.querySelector('[data-dispatch]');
  if (!el) return;
  const [cutH, cutM] = el.dataset.cutoff.split(':').map(Number);
  if (Number.isNaN(cutH)) return;
  const holidays = el.dataset.holidays.split(/[,\s]+/).filter(Boolean);
  const saturday = el.dataset.saturday === 'true';
  const fridayHold = el.dataset.fridayHold === 'true';
  const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  // Fecha y hora actuales en Madrid, como Date "local" sin zona
  const madridNow = () => {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).map((x) => [x.type, x.value]));
    return new Date(+p.year, p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
  };
  const pad = (n) => String(n).padStart(2, '0');
  const holiday = (d) => {
    const dm = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
    return holidays.includes(dm) || holidays.includes(`${dm}/${d.getFullYear()}`);
  };
  // Días en que se entrega (lunes a viernes) y en que se prepara/recoge (más el sábado si se marca)
  const delivers = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !holiday(d);
  const ships = (d) => (d.getDay() === 6 ? saturday : delivers(d));
  const nextDay = (d, ok) => {
    const n = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
    for (let i = 0; i < 21 && !ok(n); i++) n.setDate(n.getDate() + 1);
    return n;
  };

  // Antes de la hora límite se recoge hoy; si no, el siguiente día de envío.
  // Lo recogido el viernes (o sábado) sale el lunes. Llega el día laborable
  // siguiente a la salida: antes de las 16:00 de lunes a jueves = mañana;
  // del jueves por la tarde al domingo = martes. Cuenta atrás solo si quedan
  // 24 h o menos
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  // Sin segundos; los minutos se redondean hacia arriba (el último minuto es "0 h 01 min")
  const countdown = (ms) => {
    const t = Math.max(0, Math.ceil(ms / 60000));
    return `${Math.floor(t / 60)} h ${pad(t % 60)} min`;
  };
  const render = () => {
    const now = madridNow();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const beforeCut = now.getHours() * 60 + now.getMinutes() < cutH * 60 + (cutM || 0);
    const arrival = (pickup) => nextDay(fridayHold && pickup.getDay() >= 5 ? nextDay(pickup, delivers) : pickup, delivers);
    const pickup = ships(today) && beforeCut ? today : nextDay(today, ships);
    const arrives = arrival(pickup);
    // Último día de recogida que aún llega ese mismo día (del viernes al lunes
    // siempre es el martes): la cuenta atrás acaba a su hora límite
    let last = pickup;
    for (let next = nextDay(last, ships), i = 0; i < 7 && +arrival(next) === +arrives; i++) {
      last = next;
      next = nextDay(last, ships);
    }
    const deadline = new Date(last.getFullYear(), last.getMonth(), last.getDate(), cutH, cutM || 0);
    const left = deadline - now;
    const day = `${days[arrives.getDay()]} ${arrives.getDate()}${arrives.getMonth() !== today.getMonth() ? ` de ${months[arrives.getMonth()]}` : ''}`;
    const text = left > 0 && left <= 864e5
      ? el.dataset.textToday.replace('%time%', countdown(left)).replace('%day%', day)
      : el.dataset.textDay.replace('%day%', day);
    el.querySelector('[data-dispatch-text]').innerHTML = text;
    el.hidden = false;
  };
  render();
  setInterval(render, 1000);
})();

/* Ficha: en la foto de la caja ([data-box-slide]) el sello va al centro y al
   salir vuelve a su esquina; las dos veces con la animación de despegarse
   (.is-box / .is-leaving). Cambia en cuanto la caja empieza a entrar o a salir
   (5 % de recorrido), según hacia dónde se mueva. Se mira la posición real de
   cada foto (el carrusel en bucle reordena y duplica) */
(() => {
  const gallery = document.querySelector('.pdp__gallery');
  const track = gallery?.querySelector('[data-carousel-track]');
  if (!track || !track.querySelector('[data-box-slide]')) return;
  let ticking = false;
  let prev = null;
  let leaveTimer = null;
  const check = () => {
    ticking = false;
    const left = track.scrollLeft;
    let d = Infinity;
    let w = track.clientWidth;
    track.querySelectorAll('[data-box-slide]').forEach((slide) => {
      const dist = Math.abs(slide.offsetLeft - track.offsetLeft - left);
      if (dist < d) { d = dist; w = slide.offsetWidth; }
    });
    const was = gallery.classList.contains('is-box');
    let box = was;
    if (prev === null) box = d < w * 0.5;
    else if (d < prev) box = d < w * 0.95;
    else if (d > prev) box = d < w * 0.05;
    prev = d;
    if (box === was) return;
    gallery.classList.toggle('is-box', box);
    clearTimeout(leaveTimer);
    gallery.classList.toggle('is-leaving', !box);
    if (!box) leaveTimer = setTimeout(() => gallery.classList.remove('is-leaving'), 1200);
  };
  track.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(check); }
  }, { passive: true });
  check();
  gallery.classList.remove('is-leaving');
})();

// Factura a empresa (cesta lateral y /cart): los datos son atributos del
// carrito. Se guardan al escribir para que no se pierdan cuando la cesta se
// vuelve a pintar (cambio de cantidad) y se vacían al desmarcar la casilla.
// Al finalizar compra el formulario los manda igualmente (campos con form=).
(() => {
  const url = `${window.Shopify?.routes?.root || '/'}cart/update.js`;
  let timer = null;

  const save = (block) => {
    clearTimeout(timer);
    const on = block.querySelector('[data-invoice-toggle]').checked;
    const [company, taxId] = block.querySelectorAll('[data-invoice-field]');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Factura a empresa': on ? 'Sí' : '',
          'Razón social': on ? company.value.trim() : '',
          'NIF/CIF': on ? taxId.value : '',
        },
      }),
    }).catch(() => {});
  };

  document.addEventListener('change', (event) => {
    const block = event.target.closest('[data-cart-invoice]');
    if (!block) return;
    if (event.target.matches('[data-invoice-toggle]')) {
      const on = event.target.checked;
      block.querySelectorAll('[data-invoice-field]').forEach((field) => {
        field.required = on;
        if (!on) field.value = '';
      });
      if (on) block.querySelector('[data-invoice-field]').focus();
    }
    // NIF en mayúsculas y sin espacios ni guiones
    if (event.target.name === 'attributes[NIF/CIF]') {
      event.target.value = event.target.value.toUpperCase().replace(/[\s.-]/g, '');
    }
    save(block);
  });

  document.addEventListener('input', (event) => {
    const block = event.target.closest('[data-cart-invoice]');
    if (!block || !event.target.matches('[data-invoice-field]')) return;
    clearTimeout(timer);
    timer = setTimeout(() => save(block), 600);
  });
})();

// Preferencias de cookies: el banner de Shopify no vuelve a salir tras elegir.
// Se muestra el botón cuando ya hay decisión (aceptar o rechazar) y al pulsarlo
// se reabre el panel de preferencias del banner.
(() => {
  const button = document.querySelector('[data-cookie-prefs]');
  if (!button) return;

  const decided = () => {
    const consent = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
    return ['marketing', 'analytics', 'preferences'].some((k) => consent[k] === 'yes' || consent[k] === 'no');
  };
  const update = () => {
    button.hidden = !(window.privacyBanner?.showPreferences && decided());
  };

  button.addEventListener('click', () => window.privacyBanner?.showPreferences?.());
  document.addEventListener('visitorConsentCollected', () => setTimeout(update, 300));
  document.addEventListener('consentTrackingApiLoaded', update);
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (!error) update();
  });
  window.addEventListener('load', () => setTimeout(update, 1000));
})();
